import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const BarChart = ({ data, options, height, width = '100%' }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTab, setIsTab] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);
  useEffect(() => {

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTab(window.innerWidth > 768 && window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  // Dynamically calculate max value from dataset
  const maxY = Math.max(...data.datasets[0].data);
  const paddedMaxY = Math.ceil(maxY / 10) * 10 +20; // round up to nearest 10
  
  const updatedOptions = {
    ...options,
    scales: {
      ...options.scales,
      y: {
        ...options.scales?.y,
        beginAtZero: true,
        max: paddedMaxY,
      },
    },
  };

  

  return (
    <div style={{ width, height, justifyContent: 'center', display: 'flex' }}>
      <Bar data={data} options={updatedOptions} style={{ width: isMobile ? '100%' : isTab ? '75%' : '50%' }} />
    </div>
  );
};

export default BarChart;
